const constants = {
	keyCodes: {
		escape: 27,
		enter: 13,
	},
};

export { constants };
